import { repArtistsUrl } from '../urls';
import refresh from '../refresh';

export async function getRepArtists() {
  return refresh(async () => {
    const response = await fetch(repArtistsUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}

export async function patchRepArtistsRevoked(artistId) {
  const data = {
    artist: artistId,
  };
  return refresh(async () => {
    const response = await fetch(repArtistsUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify(data),
    });
    return response;
  });
}
